import { MassActionTypes } from './mass.types';

export const updateConfig = (configArray) => ({
    type: MassActionTypes.UPDATE_CONFIG,
    payload: configArray
});


export const updateMasses = (massesArray) => ({
    type: MassActionTypes.UPDATE_MASSES,
    payload: massesArray
});


export const resetMasses = () => ({
    type: MassActionTypes.RESET_MASSES
});



